<div class="card">
  <app-header
    titulo="Sistemas"
    descricao="Todo processo de integração pertence a um sistema, como ERP ou loja virtual">
  </app-header>

  <div class="surface-50 border-1 surface-border border-round p-3 mb-4 line-height-3">
    Cadastre aqui o sistema que será atendido pela integração. Por exemplo, se um processo envia pedidos para seu ERP, associe o processo ao sistema “ERP”.
    Depois, crie o processo em <a routerLink="/smartinteg/processos">Processos</a>.
  </div>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button label="Novo Sistema" icon="pi pi-plus" severity="success" (onClick)="novoSistema()"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table [value]="sistemas" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="descricao">Descrição <p-sortIcon field="descricao"></p-sortIcon></th>
        <th pSortableColumn="dtCriado" style="width: 12rem">Criado em <p-sortIcon field="dtCriado"></p-sortIcon></th>
        <th style="width: 8rem">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-sistema>
      <tr>
        <td><strong>{{ sistema.nome }}</strong></td>
        <td>{{ sistema.descricao }}</td>
        <td>{{ sistema.dtCriado | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text" pTooltip="Editar" [attr.aria-label]="'Editar ' + sistema.nome" tooltipPosition="top" (click)="editarSistema(sistema)"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" pTooltip="Excluir" [attr.aria-label]="'Excluir ' + sistema.nome" tooltipPosition="top" (click)="deletarSistema(sistema)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center p-4">Nenhum sistema cadastrado. Cadastre o primeiro para poder criar processos.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog de Adicionar/Editar Sistema -->
<p-dialog
  [(visible)]="sistemaDialog"
  [style]="{width: '560px'}"
  [breakpoints]="{'640px': '96vw'}"
  [header]="isEditDialog ? 'Editar Sistema' : 'Novo Sistema'"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">
  <ng-template pTemplate="content">
    <div class="p-fluid grid conteudo-dialog" [formGroup]="form">
      <p class="col-12 text-600 line-height-3 mt-0">Use o nome pelo qual sua equipe reconhece a aplicação. Você poderá associar processos a ela depois.</p>
      <div class="field col-12">
        <p-floatLabel>
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [class.ng-invalid]="campoInvalido('nome')"
            [class.ng-dirty]="campoInvalido('nome')"
          />
          <label for="nome">Nome do sistema *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nome')">
          Nome é obrigatório (mínimo 3 caracteres)
        </small>
        <small class="text-500">Use um nome reconhecível pela equipe, como “ERP” ou “Loja virtual”.</small>
      </div>

      <div class="field col-12">
        <p-floatLabel>
          <textarea pInputTextarea id="descricao" formControlName="descricao" rows="3"></textarea>
          <label for="descricao">Descrição</label>
        </p-floatLabel>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" [disabled]="salvando" (click)="fecharDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-success" [loading]="salvando" (click)="salvarSistema()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
